import { render } from "./add-playgrounds.template.html?vue&type=template&id=0985b8b8&scoped=true"
import script from "./AddPlaygrounds.vue?vue&type=script&lang=ts"
export * from "./AddPlaygrounds.vue?vue&type=script&lang=ts"

import "./AddPlaygrounds.vue?vue&type=style&index=0&id=0985b8b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0985b8b8"

export default script